import { AppliedFilters } from "~/components/products-layout/components/products-filters/types";
import { ProductRequestType } from "~/types/products-request-handler";

interface Hashes {
  sorting: string;
  filters: AppliedFilters | null;
  isShop: string | null;
  productType: ProductRequestType;
}

export const applyFiltersHash = (
  hash: string,
  applyFunction: {
    applyFunc: (
      s: string,
      f: AppliedFilters,
      isShop: boolean | null,
      productType: ProductRequestType,
    ) => void;
  },
): void => {
  const initialHashes: Hashes = {
    sorting: "",
    filters: null,
    isShop: null,
    productType: ProductRequestType.Empty,
  };
  if (!hash || !hash.startsWith("#")) {
    const appliedFilters = null;
    const activeSortingParam = "";
    const isShopFilterSelected = null;
    const productType = ProductRequestType.Empty;

    applyFunction.applyFunc(
      activeSortingParam,
      appliedFilters,
      isShopFilterSelected,
      productType,
    );
    return;
  }

  const parsedObject = new URLSearchParams(hash.substring(1));

  const { sorting, filters, isShop, productType } = Array.from(
    parsedObject.entries(),
  ).reduce((hashes, hash) => {
    const [name, value] = hash;
    if (name in hashes) {
      hashes[name as keyof Hashes] = JSON.parse(value);
    }

    return hashes;
  }, initialHashes);

  if (isShop || filters || sorting) {
    const appliedFilters = filters;
    const activeSortingParam = sorting;
    const isShopFilterSelected = !!isShop;

    applyFunction.applyFunc(
      activeSortingParam,
      appliedFilters,
      isShopFilterSelected,
      productType,
    );
  }
};
